import { computed } from '@vue/composition-api';

export default function useGetStartTime (booking, currentTime) {
  const startTime = computed(() => {
    return (booking.value._startNow) ? currentTime.value : booking.value.startTime;
  });

  return {
    startTime,
  };
}
